import { Container } from 'components/atoms';
import { FormInput } from 'components/molecules';
import { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { PiAddressBook } from 'react-icons/pi';
import { useStateStorage } from 'store/state';

interface IAddressFormProps {
  propertyPrefix: string;
  title?: string;
  icon?: ReactNode;
  topContent?: ReactNode;
  bottomContent?: ReactNode;
}

const AddressForm = ({
  icon = <PiAddressBook />,
  title,
  propertyPrefix = '',
  bottomContent,
  topContent,
}: IAddressFormProps) => {
  const { t } = useTranslation();

  const { countries } = useStateStorage();

  const countryOptions =
    countries?.map(country => ({
      label: t(`countries.${country.codeAlfa2}`),
      value: country.codeAlfa2,
    })) ?? [];

  return (
    <Container className='self-start w-full max-w-[350px]'>
      <Container.Header
        title={
          <>
            {icon} {title ?? t('molecules.sections.address')}
          </>
        }
      />
      {topContent}
      <Container.Content>
        <div className='flex flex-col w-full gap-3'>
          <FormInput.Select
            name={`${propertyPrefix}countryAlfa2`}
            label={t('input.label.country')}
            options={countryOptions}
          />
          <FormInput.Text
            name={`${propertyPrefix}zipCode`}
            label={t('input.label.zipCode')}
          />
          <FormInput.Text
            name={`${propertyPrefix}city`}
            label={t('input.label.city')}
          />
          <FormInput.Text
            name={`${propertyPrefix}street`}
            label={t('input.label.street')}
          />
          <FormInput.Text
            name={`${propertyPrefix}houseNumber`}
            label={t('input.label.houseNumber')}
          />
          <FormInput.Text
            name={`${propertyPrefix}flatNumber`}
            label={t('input.label.flatNumber')}
          />
        </div>
      </Container.Content>
      {bottomContent}
    </Container>
  );
};

export default AddressForm;
